import { render } from "./StatisticPage.vue?vue&type=template&id=f312f8c2"
import script from "./StatisticPage.vue?vue&type=script&lang=js"
export * from "./StatisticPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__